import React, { useState, useEffect } from 'react';
import { Form, Field, FieldWrapper, FormElement } from '@progress/kendo-react-form';
import FormContainer from '../components/FormContainer';
import SubHeader from '../components/SubHeader';
import { FormSubTitle,FormSubTitleDesp,FormTitle } from '../validation/Form-Components';
import { ComboBox } from '@progress/kendo-react-dropdowns';
import TooltipTemplate from '../components/TooltipTemplate';
import { Tooltip } from '@progress/kendo-react-tooltip';
import config from '../appconfig/config.json';
import { useHistory } from "react-router-dom";
import CusProgressBar from '../components/CusProgressBar';
import delegateData from '../data/delegationdetailsdata.json';
import WtBgChkbox from '../components/WtBgChkbox';
import service from '../services/ApiService.js';
import CusRadioButton from '../components/CusRadioButton';
import Loading from '../components/Loading';
import conOfSigns from '../data/condofsign.json';
import helper from '../factory/Helper';
import designations from '../data/position.json';
import CusToast from '../components/CusToast';
import storage from '../factory/StorageFactory';

let holders=[];
const NSDelegationDetails2 = (props) => {
    let timer;
    const detailsType='5';
    const item = { bgcolor: "#389A6E", completed: 60 };
    const history = useHistory();
    const [condOfSign, setCondOfSign] = useState({});
    const seq0='0';
 
    const [rdoCheckedValue, setRdoCheckedValue] = useState();
    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [isSaving, setIsSaving] = useState(false);
 
    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const [response,setResponse] = useState({ApplicantsDtlsMyInfo:''});
    const [authSigns, setAuthSigns]  = useState([]);
    const [benificialOwners, setBenificialOwners] = useState([]);
    
    useEffect(() => {
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }
        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }
        window.scrollTo(0,0);
        getData();
        return () => clearTimeout(timer);
    }, []);
 
    const getData = () => {

        service.get().then( res =>{
            setIsLoading(false);
            if(res.data.isSucess){
                createHolders(res.data.model.fields.request);
                setResponse(res.data.model.fields.request);
                bindFormData(res.data.model.fields.request);
            }
            else{
                setIsLoading(false);
            }
        })
        .catch(err=>{
         
            setIsLoading(false);
            showErrMsg('Error: Get data failed.');
        })
    }

    const bindFormData = (data) => {
        try {
            if(data) {
                setRdoCheckedValue(data.IsAboveABeneficialOwner? data.IsAboveABeneficialOwner !== null? data.IsAboveABeneficialOwner:'':'');
                bindCondOfSign(data);
            
                if(data.BenificialOwner && data.BenificialOwner !== null){
                    bindBenitOwners(data);
                }
                else {
                    bindBenitOwnerFromApplicantDtls(data);
                }

                if(data.AuthSign && data.AuthSign !== null){
                    bindAuthSigns(data);
                }
                else {
                    bindAuthSingFromApplicantDtls(data);
                }
            }
        } catch(ex){
        
        }
    }

    const isFirstUser = () => {
        if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true') {
            return true;
        }
        else {
            return false;
        }
    }

    const bindCondOfSign = (data) => {
 
        if(data.SignConditionAP) {
            setCondOfSign(helper.getObjInArray(data.SignConditionAP,conOfSigns))
        }
    }

    const bindAuthSingFromApplicantDtls = (data) => {
        let authSignArray = [];
        if(data.ApplicantDtls.length === undefined){
            authSignArray.push({
                Name: data.ApplicantDtls.Name,
                IDNum: data.ApplicantDtls.IDNum,
                ApplicantSeq: data.ApplicantDtls.ApplicantSeq,
                Designation: helper.getDesignationbyIDNum(data.ApplicantDtls.IDNum,holders),
                SelectedValue: true
            })
        }
        else {
            for(let i in data.ApplicantDtls) {
                if(data.ApplicantDtls[i].ApplicantSeq !== seq0){
                    if(data.ApplicantDtls[i].Authorised === undefined || data.ApplicantDtls[i].Authorised === 'true'){
                        authSignArray.push({
                            Name: data.ApplicantDtls[i].Name,
                            IDNum: data.ApplicantDtls[i].IDNum,
                            ApplicantSeq: data.ApplicantDtls[i].ApplicantSeq,
                            Designation: helper.getDesignationbyIDNum(data.ApplicantDtls[i].IDNum,holders),
                            SelectedValue: true
                        })
                    }
                }
            }
        }
        authSignArray.sort(function(authSignA, authSignB){return parseInt(authSignA.ApplicantSeq)-parseInt(authSignB.ApplicantSeq)});

        setAuthSigns(authSignArray);
    }

    const bindBenitOwnerFromApplicantDtls = (data) =>{
        let benitOwnerArray = [];
        if(data.ApplicantDtls.length === undefined){
     
            benitOwnerArray.push({
                Name: data.ApplicantDtls.Name,
                IDNum: data.ApplicantDtls.IDNum,
                ApplicantSeq: data.ApplicantDtls.ApplicantSeq,
                Designation: helper.getDesignationbyIDNum(data.ApplicantDtls.IDNum,holders),
                SelectedValue: true
            })
        }
        else {
            for(let i in data.ApplicantDtls) {
                if(data.ApplicantDtls[i].ApplicantSeq !== seq0){
                   
                    benitOwnerArray.push({
                        Name: data.ApplicantDtls[i].Name,
                        IDNum: data.ApplicantDtls[i].IDNum,
                        ApplicantSeq: data.ApplicantDtls[i].ApplicantSeq,
                        Designation: helper.getDesignationbyIDNum(data.ApplicantDtls[i].IDNum,holders),
                        SelectedValue: true
                    })
                }
            }
        }
        benitOwnerArray.sort(function(benitOwnerA, benitOwnerB){return parseInt(benitOwnerA.ApplicantSeq)-parseInt(benitOwnerB.ApplicantSeq)});
        setBenificialOwners(benitOwnerArray);
    }

    const bindBenitOwners = (data) => {
        let benitOwnerArray = [];
        if(data.BenificialOwner && data.BenificialOwner !== null) {
            if(data.BenificialOwner.length === undefined) {   //object
                benitOwnerArray.push({
                    Name:data.BenificialOwner.Name,
                    IDNum:data.BenificialOwner.IDNum,
                    ApplicantSeq:data.BenificialOwner.ApplicantSeq,
                    Designation:data.BenificialOwner.Designation,
                    SelectedValue: data.BenificialOwner.SelectedValue === 'false'? false:true
                })
            }
            else {
                for(let i in data.BenificialOwner) {
                    benitOwnerArray.push({
                        Name: data.BenificialOwner[i].Name,
                        IDNum: data.BenificialOwner[i].IDNum,
                        ApplicantSeq: data.BenificialOwner[i].ApplicantSeq,
                        Designation: data.BenificialOwner[i].Designation,
                        SelectedValue:data.BenificialOwner[i].SelectedValue === 'false'? false:true
                    })
                }
            }
        }
        setBenificialOwners(benitOwnerArray);
    }
 
    const bindAuthSigns = (data) => {
       
        let authSignArray = [];
        if(data.AuthSign && data.AuthSign !== null) {
            if(data.AuthSign.length === undefined) {   //object
                authSignArray.push({
                    Name:data.AuthSign.Name,
                    IDNum:data.AuthSign.IDNum,
                    ApplicantSeq:data.AuthSign.ApplicantSeq,
                    Designation:data.AuthSign.Designation,
                    SelectedValue: data.AuthSign.SelectedValue === 'false'? false:true
                })
            }
            else {
                for(let i in data.AuthSign) {
                    authSignArray.push({
                        Name: data.AuthSign[i].Name,
                        IDNum: data.AuthSign[i].IDNum,
                        ApplicantSeq: data.AuthSign[i].ApplicantSeq,
                        Designation: data.AuthSign[i].Designation,
                        SelectedValue:data.AuthSign[i].SelectedValue === 'false'? false:true
                    })
                }
            }
        }
        setAuthSigns(authSignArray);
    }

    const handleSubmit = (eve) => {
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }
        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }
        
        if(!validateBeneficalOwners()) {
            showErrMsg(config.error.DelegationDetails.SelectMin1BeneOwner);
            return;
        }
        if(rdoCheckedValue === '' || rdoCheckedValue === null || rdoCheckedValue === undefined){
            showErrMsg(config.error.DelegationDetails.IsAboveABeneficialOwner);
            return;
        }

        if(eve.isValid){
            let data = JSON.parse(JSON.stringify(eve.values));
            saveDeleDetails(formatJsonParams(data))
        }
    }

    const saveDeleDetails = (params) =>{
        setIsSaving(true);
        service.post(detailsType,params).then(res=>{
            setIsSaving(false);
            let resData = res.data;
            if(resData.isSucess) {
                goNext();
            }
            else {
                showErrMsg(config.error.SaveApiFailed);
            }    
        })
        .catch(err => {
            setIsSaving(false);
            showErrMsg(config.error.SaveApiFailed);
        });
    }

    const getUnSelectedBeneOwners = () => {
        let unselectedBeneOwners = [];
        for(let i in benificialOwners) {
            if(benificialOwners[i].SelectedValue === false) {
                unselectedBeneOwners.push(benificialOwners[i].SelectedValue);
            }
        }
        return unselectedBeneOwners;
    }
    const validateBeneficalOwners = () => {
        let isValid = true;
        if(getUnSelectedBeneOwners().length === benificialOwners.length) {
            isValid = false;
        }
        return isValid;
    }

    const createHolders = (data) => {
        let temp = [];
        let myInfoAppDtls = {
            IDNum:data.ApplicantsDtlsMyInfo.IDNum,
            Name:data.ApplicantsDtlsMyInfo.Name,
            Designation:data.ApplicantsDtlsMyInfo.Designation !==null? data.ApplicantsDtlsMyInfo.Designation:'',
            Nationality:data.ApplicantsDtlsMyInfo.Nationality !==null? data.ApplicantsDtlsMyInfo.Nationality:''
        }
        if(!Array.isArray(data.Holdersdetails)) {
            // temp.push(myInfoAppDtls); //no need to add login user
            if(data.Holdersdetails.IDNum !== null && data.Holdersdetails.Name !== null) {
                temp.push(data.Holdersdetails);
                holders = temp;
            }
        }
        else {
            // temp.push(myInfoAppDtls); //no need to add login user
            for(let i in data.Holdersdetails) {
                if(data.Holdersdetails[i].IDNum !== null && data.Holdersdetails[i].Name !== null){
                    temp.push(data.Holdersdetails[i]);
                }
            }
            holders = temp;
        }
    }

    const goNext = () => {
        if(history.location.state !== undefined) {
            if(history.location.state.from === config.route.Preview) {
                history.goBack();
            }
        }
        else {
            if(isFirstUser()){
                history.push(config.route.NSTaxDetails);
            }
            else {
                if(storage.getIsLoginUserShareholder() !== null && storage.getIsLoginUserShareholder() === 'true') {
                    history.push(config.route.DeclarationDetails);
                    return;
                }
                history.push(config.route.NSUploadDetails);
            }
        }
    }

    let formatJsonParams = function(data) {
        let params = {
            ASBOConOfSign:condOfSign.value,  
            AuthSign:authSigns,
            BenificialOwner:benificialOwners,
            IsAboveABeneficialOwner:rdoCheckedValue
        }
        return params;
    }

    const onRdoHandleChange = React.useCallback( (e) =>{
         setRdoCheckedValue(e.value);
    },[setRdoCheckedValue])
    
  
    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    const getDesignationLabel = (code) => {
        if(code !== undefined && code !==null && code !== '') {
            return helper.getObjInArray(code,designations).label;
        }
        return '';
    }

    const handleBackBtnClick = (e) => {
        e.preventDefault();
        if(storage.getIsLoginUserShareholder() !== null && storage.getIsLoginUserShareholder() === 'true'){
            history.push(config.route.ShareholdersDetails);
        }
        else {
            history.push(config.route.NSDelegationDetails);
        } 
    }

    if(isLoading) {
        return(
            <Loading />
        )
    }

    return(
        <div className="container-fluid">
            <SubHeader />
            <FormContainer>
                <Form  
                    onSubmitClick={handleSubmit} 
                    render={(formRenderProps) => (
                    <FormElement>
                    <fieldset>
                        <Field component={FormTitle} id={'fst1'} name={delegateData.formContainerTitle.NST2.name} />
                            <FieldWrapper>
                            <div className="row around-xs inputPair elementVisible">
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                <div className="box" id={'lblSignConditionAP'} >
                                    <div style={{width:'94%', float:"left"}}><span>{delegateData.label.conOfSign}</span>
                                    </div>
                                    <div style={{width:'6%', float:"right"}}>
                                        <Tooltip id={'ttSignConditionAP'} content={(props) => 
                                            <TooltipTemplate id={'tttSignConditionAP'} title={props.title}/>} 
                                                anchorElement={'target'} position={'left'} >
                                            <span className="k-icon k-i-information" title={delegateData.tooltip.conOfSign}></span> 
                                        </Tooltip>
                                    </div>
                                 </div>
                            </div>
                     
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6" style={{paddingTop:'2px'}}>
                                <div className="box">
                                    <ComboBox
                                        id="ASBOConOfSign" name="ASBOConOfSign"
                                        clearButton={false}
                                        data={conOfSigns}
                                        textField="label"
                                        dataItemKey="value"
                                        disabled={true}
                                        value={condOfSign}/>
                                </div> 
                            </div>
                        </div>
                        </FieldWrapper>
                        
                         <Field component={FormSubTitle} id={'fstST2'} 
                                    name={delegateData.formSubTitle.ST2}   />
                                    
                        <Field component={FormSubTitleDesp} id={'fstSTD2'} 
                                    name={delegateData.formSubTitleDesp.STDNS2}  />

                        {authSigns.map((item, idx) => (
                            <WtBgChkbox key={idx} id={item.IDNum} label={item.Name} rightLabel={getDesignationLabel(item.Designation)}
                                checkedValue={true}
                                disabled={true}
                                onCheckedChange={(v,id)=>{
                                    authSigns[idx].SelectedValue = v;
                                }} />))}

                        <Field component={FormSubTitle} id={'fstST3'} 
                                    name={delegateData.formSubTitle.ST3} />
                                    
                        <Field component={FormSubTitleDesp} id={'fstSTD3'} 
                                    name={delegateData.formSubTitleDesp.STD3} />

                        <Field component={FormSubTitle} id={'fstST3'} 
                                    name={delegateData.label.beneOwner} />

                        {benificialOwners.map((item, idx) => (
                            <WtBgChkbox key={idx} id={item.IDNum} label={item.Name} rightLabel={getDesignationLabel(item.Designation)}
                                checkedValue={item.SelectedValue}
                                disabled={!isFirstUser()}
                                onCheckedChange={(v,id)=>{
                                    benificialOwners[idx].SelectedValue = v;
                                }} />))}

                    <FieldWrapper style={{paddingTop:'10px'}}>
                     
                        <CusRadioButton name="rdoBeneOwner" leftValue='Y' rightValue='N' disabled={!isFirstUser()}
                            label={delegateData.label.rdoBeneOwner} onChange={onRdoHandleChange} checkedValue={rdoCheckedValue} />
                    </FieldWrapper>
                    <FieldWrapper>
                    <CusProgressBar  bgcolor={item.bgcolor} completed={item.completed} /> 

                    <div className="row around-xs inputPair elementVisible" style={{ paddingBottom: "20px" }}>
                        <div  className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <button className="btn btn-back" onClick={handleBackBtnClick}>{config.btnName.Back}</button>
                            <button type={'submit'} className="k-button btn btn-success btn-float-right"  disabled={!formRenderProps.valid}>{config.btnName.Next}</button>
                        </div>
                    </div> 

                    </FieldWrapper>

                    {/* {isError && <CusNotification msg={errMsg} closable={true} status={'error'} 
                            onClose={()=>{ setIsError(false)}} />} */}

                    <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} />

                      </fieldset>
                    </FormElement>
                )}>
                </Form>
            </FormContainer>
            {isSaving && <Loading />} 
        </div>
    )
}

export default NSDelegationDetails2